module.exports = __webpack_public_path__ + "img/ect.68a08db6.svg";